
import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import { BContainer, BRow, BCol } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SelectAutocomplete from "@/components/input/SelectAutocomplete.vue";
import api from "@/api";

@Component({
    components: {
        BRow,
        BContainer,
        BCol,
        ValidationObserver,
        ValidationProvider,
        SelectAutocomplete,
    },
})
export default class ModalAddMaterial extends Vue {
    @Prop({ required: true }) ticketId!: string;
    modalShow = false;

    materials: any[] = [];
    materials_number: any[] = [];
    materials_name: any[] = [];

    material_id: number | null = null;
    proposed_qty: number | null = null;
    remaining_qty: number | null = null;
    description: string | null = null;
    uom: string | null = null;
    sparepart_no: string | null = null; 
    item_name: string | null = null;
    remaining_stock: number | null = null;

    isActiveMatNum = false;
    isActiveMatName = false;
    isActiveDesc = false;
    isActivePropQty = false;
    isActiveUom = false;
    isActiveRemaining = false;

    cekMatNum() {
        if (this.material_id) {
            this.isActiveMatNum = true;
        } else {
            this.isActiveMatNum = false;
        }
    }
    cekMatName() {
        if (this.material_id) {
            this.isActiveMatName = true;
        } else {
            this.isActiveMatName = false;
        }
    }
    cekDesc() {
        if (this.description) {
            this.isActiveDesc = true;
        } else {
            this.isActiveDesc = false;
        }
    }
    cekPropQty() {
        if (this.proposed_qty) {
            this.isActivePropQty = true;
        } else {
            this.isActivePropQty = false;
        }
    }
    cekUom() {
        if (this.uom) {
            this.isActiveUom = true;
        } else {
            this.isActiveUom = false;
        }
    }
    cekRemaining() {
        if (this.remaining_qty) {
            this.isActiveRemaining = true;
        } else {
            this.isActiveRemaining = false;
        }
    }

    @Watch("material_id")
    onMaterialChange(newVal: number) {
        if (newVal) {
            const material = this.materials.find((e) => e.id == newVal);
            this.description = material.item_name;
            this.uom = material.uom;
            this.sparepart_no = material.sparepart_no;
            this.item_name = material.item_name;
            this.remaining_qty = material.remaining_stock;
            this.uom = material.uom;
            this.remaining_stock = material.remaining_stock;
        }
    }

    mounted() {
        // console.log(this.ticketId)
        api.options.getMaterials(this.ticketId).then((response) => {
            if (response.data.code === 200) {
                this.materials = response.data.data;
                this.materials_number = this.materials.map((e) => ({ 
                    value: e.id,
                    text: e.sparepart_no
                }));
                this.materials_name = this.materials.map((e) => ({ 
                    value: e.id,
                    text: e.item_name
                }));
            }
        });
    }
    closeModal() {
        this.modalShow = false;
        setTimeout(() => {
            this.material_id = null;
            this.proposed_qty = null;
            this.remaining_qty = null;
            this.description = null;
            this.item_name = null;
            this.uom = null;
            this.sparepart_no = null;
        }, 200);
    }
    showModal() {
        this.modalShow = true;
    }
    saveMaterial() {
        this.$emit("onSave", {
            material_id: this.material_id,
            proposed_qty: this.proposed_qty,
            remaining_qty: this.remaining_qty,
            description: this.description,
            uom: this.uom,
            sparepart_no: this.sparepart_no,
            item_name: this.item_name
        });
        this.closeModal();
    }
}
